import React from 'react'

import ConnectMiddleware from '@/plugins/auth/RouteRedirectors/ConnectMiddleware'
import { BodyStack } from '@/styled/components'

import HelpDrawer from '../HelpDrawer/HelpDrawer'
import FeaturedCollections from './FeaturedCollections'
import FeaturedCreators from './FeaturedCreators'
import FeaturedDapps from './FeaturedDapps'
import FeaturedItems from './FeaturedItems'
import GuidesUpdatesCarousel from './GuidesUpdatesCarousel'
import WhatsNew from './WhatsNew'

const Component: React.FC = () => (
  <ConnectMiddleware>
    <BodyStack style={{ gap: '60px', padding: '0 25px' }}>
      <WhatsNew />
      <FeaturedItems />
      <FeaturedCreators />
      <FeaturedCollections />
      <FeaturedDapps />
      <GuidesUpdatesCarousel />
    </BodyStack>
    <HelpDrawer id="home" />
  </ConnectMiddleware>
)
Component.displayName = 'HomePage'

// eslint-disable-next-line import/prefer-default-export
export { Component }
